const state = {

    routeHis:[]

}

const mutations = {

     MrouteSet(state,hashDat){
          state.routeHis.push(hashDat)
     }

}

const actions = {

     ArouteSet({commit,state},hashDat){
          commit('MrouteSet',hashDat)
     }

}

export default {
    namespaced:true,
    state,
    mutations,
    actions
}
